export default "__VITE_ASSET__25aa8427__"